import React, { FC } from "react";
import styled from "styled-components";
import { loadingColour, loadingTextColour, endText } from "../env";

interface Props {
  className?: string;
}

const EndScreen: FC<Props> = ({ className }) => {
  return (
    <EndBackground className={className || ""}>
      <EndDiv>
        <EndImage src="android-chrome-512x512.png" />
        <EndText>{endText}</EndText>
      </EndDiv>
    </EndBackground>
  );
};

const EndBackground = styled.div`
  width: 100%;
  height: 100%;
  background: ${loadingColour};
  color: ${loadingTextColour};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const EndDiv = styled.div``;

const EndImage = styled.img`
  max-width: 12em;
  max-height: 12em;
  margin-bottom: 1em;
`;

const EndText = styled.div`
  font-size: 1.4em;
`;

export { EndScreen };
